import { Header, Sidebar } from "@/src/components";
import { NavProvider } from "@/src/context";

export const UserLayout = ({ children }) => {
  return (
    <NavProvider>
      <div className="min-h-screen flex bg-background bg-gradient-mesh transition-colors duration-300">
        <Sidebar />
        <div className="flex-grow flex flex-col min-w-0">
          <Header />
          <main className="flex-grow animate-fade-in">{children}</main>
        </div>
      </div>
    </NavProvider>
  );
};
